import { useEffect, type ReactNode } from 'react';
import { initTelemetry } from '../lib/telemetry';

interface TelemetryProviderProps {
  children: ReactNode;
}

/**
 * TelemetryProvider initializes OpenTelemetry for browser instrumentation
 * Enables trace context propagation to backend APIs
 */
export function TelemetryProvider({ children }: TelemetryProviderProps) {
  useEffect(() => {
    const enabled = import.meta.env.VITE_TELEMETRY_ENABLED === 'true';

    initTelemetry({
      serviceName: 'platform-portal',
      serviceVersion: '0.1.0',
      enabled,
    });
  }, []);

  return <>{children}</>;
}
